module.exports = __webpack_public_path__ + "static/media/IlotD_BIM_1_RED.34a71ec9.webp";